//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'DirectionsSelect',
  props: ['currentDirection', 'directions', 'loading', 'filter', 'applyFilter'],
  watch: {
    '$app.isMobile'() {
      if (this.$app.isMobile) {
        window.$(document).on('click', this.closeDirectionOptionsList);
      } else {
        window.$(document).off('click', this.closeDirectionOptionsList);
      }
    },
  },
  mounted() {
    if (this.$app.isMobile) {
      window.$(document).on('click', this.closeDirectionOptionsList);
    }
  },
  methods: {
    selectToggleHandler() {
      if (this.$app.isMobile) {
        window.$(this.$refs.parent).toggleClass('is-active');
        window.$(this.$refs.selectBody).slideToggle(150);
      }
    },
    closeDirectionOptionsList(evt) {
      if (this.$app.isMobile) {
        let $target = window.$(evt.target);
        if (
          !window.$(this.$refs.parent).is($target) &&
          window.$(this.$refs.parent).has($target).length === 0
        ) {
          if (window.$(this.$refs.parent).hasClass('is-active')) {
            window.$(this.$refs.parent).removeClass('is-active');
            window.$(this.$refs.selectBody).slideUp(150);
            evt.preventDefault();
            evt.stopPropagation();
          }
        }
      }
    },
    closeSelect() {
      if (this.$app.isMobile) {
        window.$(this.$refs.parent).removeClass('is-active');
        window.$(this.$refs.selectBody).slideUp(150);
      }
    },
  },
};
